export const navLinks = [
  { label: 'Home',         path: '/' },
  { label: 'About Us',     path: '/about' },
  { label: 'Services',     path: '/services' },
  { label: 'Projects',     path: '/projects' },
  { label: 'Testimonials', path: '/testimonials' },
  //{ label: 'Careers',      path: '/careers' },
  { label: 'Blog',         path: '/blog' },
  { label: 'Contact',      path: '/contact' },
]
